<div class="items__select-area">
    <div class="wrapper-items__select-area">
        <div class="checkable-block" [ngClass]="{selected: selected}">
            <div class="circle-icon">
                <span class="icon icon-progress-check hidden"></span>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</div>